module.exports = __webpack_public_path__ + "img/9788995683651.70bd7eb8.jpg";